import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '../../util_grid/grid';
import WishlistToggle from '../../ui_wishlist_toggle/component';
import AddToCartButton from '../../ui_add-to-cart-button/component';
import PriceBlock from '../../base_price-block/component';
import Link from '../../base_link/component';
import { TitleAndSubtitle, ProductImage, Badge } from 'audamatic-ui';
import { Product } from '@utils/product';
import Text from '@components/ui_text/component';
import './styles/styles.scss';


/**
 * The ankeiler Highlight is a variant of ankeiler (component).
 * You can render a ankeiler with variant = highlight and it will render this component
 *
 * It should be rendered inside a grid.
 *
 * This variant shows a tile with some highlights of a product.
 * Like image, name, price etc and it has a order button.
 *
 * @todo: open sidepanel for vriendenkorting explenation
 * @todo: reserveer
 * @todo: zonder bestelknop
 * @todo: get it working in a grid
 *
 */
class AnkeilerHighlight extends Component {
  constructor(props) {
    super(props);

    this.state = {
      xsHeight: 400,
      smHeight: 640,
      lgHeight: 684,
    };

    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentDidMount() {
    this.setState({ height: this.calcHeight() });
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  get product() {
    // If ankeiler has props.products (as banner) use first product, else default to props.product
    const { products, product } = this.props;
    return (products && !!products.length) ? new Product(products[0]) : product;
  }

  get name() {
    return this.product.name || null;
  }

  get title() {
    return this.props.title;
  }

  get action() {
    return this.props.action || this.props.name || null;
  }

  get url() {
    return this.product.url || '#';
  }

  get image() {
    return this.product.image;
  }

  get sku() {
    return this.product.SKU || '';
  }

  get offered() {
    return this.product.offered || 0;
  }

  get type() {
    return this.product.type || '';
  }

  get store() {
    return this.props.store || {};
  }

  get componentType() {
    // eslint-disable-next-line
    return this.props['component-type'];
  }

  get backgroundImage() {
    return this.props.backgroundImage || '';
  }

  /**
   * Get the badges that are in the content. If non specified then return an empty array.
   *
   */
  get badges() {
    return Array.isArray(this.props.badges) ? this.props.badges : this.product.badges;
  }


  /**
   * Reset some states when you leave the object with you mouse
   */
  handleMouseLeave(e) {
    e.preventDefault();

    if (window.innerWidth >= 992) {
      this.setState({ height: this.calcHeight() });
    }
  }

  /**
   * Update the height of the ankeiler when you hover over it
   */
  handleMouseEnter(e) {
    e.preventDefault();

    if (window.innerWidth >= 992) {
      const newHeight = this.elExtend.clientHeight + this.elPicture.clientHeight + this.elAction.clientHeight + 60;
      const currentHeight = this.calcHeight();
      if (newHeight > currentHeight) {
        this.setState({ height: (newHeight) });
      }
    }
  }

  /**
   * Update the ankeiler height when the windows size is changing
   */
  updateDimensions() {
    this.setState({ height: this.calcHeight() });
  }

  /**
   * Calculate the height of the ankeiler based on the window width
   *
   * @returns {number}
   */
  calcHeight() {
    if (window.innerWidth <= 767) {
      return this.state.xsHeight;
    }
    if (window.innerWidth > 767 && window.innerWidth < 1200) {
      return this.state.smHeight;
    }
    if (window.innerWidth >= 1200) {
      return this.state.lgHeight;
    }
  }

  render() {
    const styles = { height: this.state.height };

    return (
      <Col xs={12} sm={12} md={12} lg={6} className="grid-item grid-item--height2 ankeiler ankeiler__highlight ankeiler__expandable expandable ankeiler-highlight"
        style={styles}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {!!this.badges.length &&
          <div className="tag-wrapper">
            <Badge variant="tag" text={<Text>comp.linebadge.promotion</Text>} size="tiny"/>
          </div>
        }

        <div className="add-to-booklist-container right" data-test-id="icon-addToWishlist">
          <WishlistToggle product={this.product} store={this.store}/>
        </div>

        <div className="row-centered">
          <div className="col-centered action hidden-xs" ref={e => this.elAction = e}>
            {this.action}
          </div>
        </div>

        <Row className="row-content">
          <Col xs={12}>
            <div className="image wrapper large" ref={e => this.elPicture = e}>
              {this.backgroundImage && (
                <div
                  className="background-image"
                  style={{ backgroundImage: `url(${this.backgroundImage})` }}
                />
              )}
              <Link
                to={this.product.url}
                title={this.product.name}
                onClick={this.pushGoogleTags}
              >
                <div className="product-image-wrapper">
                  <ProductImage
                    product={this.product}
                  />
                </div>
              </Link>
            </div>
            <div className="row-centered block-extend" ref={e => this.elExtend = e}>
              <Col xs={12} sm={8} md={7} lg={8} className="col-centered">
                <div className="ankeiler-container">
                  <div className="layout-top haslink">
                    <TitleAndSubtitle
                      title={this.title}
                      subtitle={this.product.personsLinks}
                      data-test-id="titleAndSubtitle"
                    />
                  </div>
                  <div className="equal-cols">
                    <PriceBlock product={this.product} store={this.store} />
                    <Col xs={12} className="recommendations no-gutter">
                      <Col xs={12} className="to-basket-container">
                        <div className="to-basket">
                          <AddToCartButton
                            hideIcon
                            store={this.store}
                            product={this.product}
                            showQuantity={false}
                          />
                        </div>
                      </Col>
                    </Col>
                  </div>
                </div>
              </Col>
            </div>
          </Col>
        </Row>
      </Col>
    );
  }
}


/**
 * The most props are part of the general product JSON
 * see the general product JSON
 */
AnkeilerHighlight.propTypes = {
  /**
   * The title in top of the ankeiler
   * wich shows an action i.e. "Speciaal voor jou geselecteerd"
   */
  action: PropTypes.string,
  /**
   * The images object
   * see the general product JSON
   */
  images: PropTypes.object,
  /**
   * The rating for the product
   * 0-10
   * see the general product JSON
   */
  rating: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  /**
   * The SKU of the product
   * see the general product JSON
   */
  SKU: PropTypes.string,
  /**
   * The url for the product detail page
   * see the general product JSON
   */
  url: PropTypes.string,
  /**
   * The name of the product
   * see the general product JSON
   */
  name: PropTypes.string,
  /**
   * The priceobject of the product
   * see the general product JSON
   */
  price: PropTypes.object,
  /**
   * The badges to show over the ankeiler
   * Follow the badges component data
   */
  badges: PropTypes.array,
  'image-shadow': PropTypes.bool,
  /**
   * The offered flag is provided by BE and
   * indicates the availability of the product as:
   * 1 - In winkelmand
   * 2 - Reserveer
   * 3 - Bekijk aanbieders
   */
  offered: PropTypes.number,
  /**
   * The product type
   */
  type: PropTypes.string,

  /**
   * The store
   */
  store: PropTypes.object,
  /**
   * Function that returns google tag push to datalayer
   *  methods for ankeilers
   */
  googleTagMethods: PropTypes.func,
  /**
   * Optional parameter adds a background image for promotional ankeilers
   * like 'De goudestrop'
   */
  backgroundImage: PropTypes.string,
  products: PropTypes.array,
  title: PropTypes.object,
  quantity: PropTypes.string,
  product: PropTypes.object,
};


export default AnkeilerHighlight;
